import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
export function MembershipsSection() {
  const memberships = [{
    type: 'Personal',
    title: 'The Jolu Circle',
    description: 'An exclusive membership for our most dedicated patrons, offering priority access and bespoke experiences.',
    benefits: ['Priority reservations across all concepts', 'Invitations to exclusive tasting events', 'Complimentary birthday dining experience', 'Dedicated concierge service'],
    href: '/memberships/personal'
  }, {
    type: 'Corporate',
    title: 'Enterprise Partners',
    description: 'Tailored solutions for businesses seeking premium dining and event experiences for clients and teams.',
    benefits: ['Preferred rates on private dining spaces', 'Corporate catering priority scheduling', 'Customized corporate gifting programs', 'Flexible billing and account management'],
    href: '/memberships/corporate'
  }];
  return <section id="memberships" className="py-32 md:py-40 bg-brand-dark relative overflow-hidden" data-id="element-177">
      {/* Noise Overlay */}
      <div className="absolute inset-0 bg-noise pointer-events-none z-20 opacity-30" data-id="element-178"></div>

      {/* Decorative Monogram/Pattern */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-5 pointer-events-none z-0" data-id="element-179">
        <img src="https://cdn.magicpatterns.com/uploads/cPkLq24FKKtQpiCoiqri7q/Ресурс_1.svg" alt="" className="w-[800px] h-[800px] filter invert" data-id="element-180" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-181">
        <div className="text-center mb-20 md:mb-32" data-id="element-182">
          <motion.h2 className="text-5xl md:text-6xl font-serif text-white mb-6" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-183">
            Memberships
          </motion.h2>
          <motion.div className="w-24 h-1 bg-brand-gold mx-auto" initial={{
          opacity: 0,
          scaleX: 0
        }} whileInView={{
          opacity: 1,
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-184"></motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto" data-id="element-185">
          {memberships.map((membership, index) => <motion.div key={index} className="relative group" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} data-id="element-186">
              {/* Animated Border */}
              <div className="absolute inset-0 border border-white/10 rounded-sm z-0" data-id="element-187"></div>
              <motion.div className="absolute inset-0 border border-brand-gold rounded-sm z-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" initial={false} data-id="element-188"></motion.div>

              {/* Glass Card */}
              <div className="bg-white/5 backdrop-blur-md p-10 md:p-14 rounded-sm shadow-2xl relative overflow-hidden h-full flex flex-col z-10" data-id="element-189">
                <div className="absolute top-0 right-0 w-40 h-40 bg-brand-terracotta/10 rounded-bl-full -mr-10 -mt-10 transition-transform duration-700 ease-out group-hover:scale-[2.5] group-hover:bg-brand-red/20" data-id="element-190"></div>

                <div className="relative z-10 flex-1" data-id="element-191">
                  <span className="text-brand-gold text-sm uppercase tracking-[0.3em] font-medium mb-4 block" data-id="element-192">
                    {membership.type}
                  </span>
                  <h3 className="text-4xl font-serif text-white mb-6" data-id="element-193">
                    {membership.title}
                  </h3>
                  <p className="text-white/60 font-light mb-12 leading-relaxed text-lg" data-id="element-194">
                    {membership.description}
                  </p>

                  <ul className="space-y-6 mb-12" data-id="element-195">
                    {membership.benefits.map((benefit, bIndex) => <li key={bIndex} className="flex items-start gap-4" data-id="element-196">
                        <div className="mt-1 bg-brand-gold/20 p-1 rounded-full text-brand-gold" data-id="element-197">
                          <Check size={16} strokeWidth={3} data-id="element-198" />
                        </div>
                        <span className="text-white/80 font-light text-lg" data-id="element-199">
                          {benefit}
                        </span>
                      </li>)}
                  </ul>
                </div>

                <div className="relative z-10 mt-auto" data-id="element-200">
                  <Link to={membership.href} className="block w-full border border-brand-gold text-brand-gold py-5 uppercase tracking-[0.2em] text-sm hover:bg-brand-gold hover:text-brand-dark transition-colors duration-300 font-medium text-center" data-id="element-201">
                    Inquire Now
                  </Link>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}